// extracted by mini-css-extract-plugin
module.exports = {"colors":"\"../../components/colors/colors.module.css\"","key-light-base":"#FFFFFF","container":"Ufyz8HKsnF65mWWYZtqkTA=="};